export default (transformFunc, defaultPayload) => (state = {
  fetching: false,
  fetched: false,
  payload: defaultPayload,
  params: {},
  error: undefined,
}, action) => {
  switch (action.type) {
    case 'FETCH_USERS_REQUEST': {
      return {
        fetching: true,
        fetched: false,
        payload: defaultPayload,
        params: action.params,
      };
    }

    case 'FETCH_USERS_SUCCESS': {
      return {
        fetching: false,
        fetched: true,
        payload: transformFunc ? transformFunc(action.payload) : action.payload,
        params: action.params,
      };
    }

    case 'FETCH_USERS_ERROR': {
      return {
        error: action.error,
        fetching: false,
        fetched: true,
        payload: defaultPayload,
        params: action.params,
      };
    }

    case 'FETCH_USERS_CLEAR': {
      return {
        fetching: false,
        fetched: false,
        payload: defaultPayload,
        params: {},
        error: undefined,
      };
    }

    case 'UPDATE_SELECTED_TABLE': {
      return {
        ...state,
        selectedTable: action.selectedTable,
      };
    }

    case 'UPDATE_SELECTED_PAGE': {
      return {
        ...state,
        selectedPage: action.selectedPage,
      };
    }

    default:
      return state;
  }
};
